import dispatcher from "../dispatcher";
import {doGetApiCall} from "../apicommunication"
import Language from "orbiter-core/src/datastructures/languages/Language";
import I18n from "../i18n";

export function retrieveAllLanguages() {
    doGetApiCall("core/languages/retrieve/all", function (result) {

        dispatcher.dispatch({
            type: "RETRIEVE_ALL_LANGUAGES",
            languages : result.languages.map(l => new Language(l.language.id, l.language.descriptor, l.language.description))
        });

    }, true);
}

export function changeLocale(locale: string, i18n: I18n) {
    dispatcher.dispatch({
        type: "CHANGE_LOCALE",
        i18n: i18n,
        locale: locale
    });
}